/* eslint-disable */
import fileSaver from 'file-saver';
// require('script-loader!src/vendor/Blob');
require('@/lib/Blob');
import XLSX from 'xlsx';
import XlsxPopulate from "xlsx-populate";

function generateArray(table) {
    var out = [];
    var rows = table.querySelectorAll('tr');
    var ranges = [];
    for (var R = 0; R < rows.length; ++R) {
        var outRow = [];
        var row = rows[R];
        var columns = row.querySelectorAll('td');
        for (var C = 0; C < columns.length; ++C) {
            var cell = columns[C];
            var colspan = cell.getAttribute('colspan');
            var rowspan = cell.getAttribute('rowspan');
            var cellValue = cell.innerText;
            if (cellValue !== "" && cellValue == +cellValue) cellValue = +cellValue;

            //Skip ranges
            ranges.forEach(function(range) {
                if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
                    for (var i = 0; i <= range.e.c - range.s.c; ++i) outRow.push(null);
                }
            });

            //Handle Row Span
            if (rowspan || colspan) {
                rowspan = rowspan || 1;
                colspan = colspan || 1;
                ranges.push({ s: { r: R, c: outRow.length }, e: { r: R + rowspan - 1, c: outRow.length + colspan - 1 } });
            };

            //Handle Value
            outRow.push(cellValue !== "" ? cellValue : null);

            //Handle Colspan
            if (colspan)
                for (var k = 0; k < colspan - 1; ++k) outRow.push(null);
        }
        out.push(outRow);
    }
    return [out, ranges];
};

function datenum(v, date1904) {
    if (date1904) v += 1462;
    var epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function sheet_from_array_of_arrays(data, opts) {
    var ws = {};
    var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
    for (var R = 0; R != data.length; ++R) {
        for (var C = 0; C != data[R].length; ++C) {
            if (range.s.r > R) range.s.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.r < R) range.e.r = R;
            if (range.e.c < C) range.e.c = C;
            var cell = { v: data[R][C] };
            if (cell.v == null) continue;
            let value = cell.v
            var cell_ref = XLSX.utils.encode_cell({ c: C, r: R });
            // 设置cell类型，百分比数据转换成数字类型并设置为'0.0%'格式
            if (typeof value === 'number') cell.t = 'n';
            else if (typeof value === 'boolean') cell.t = 'b';
            else if (value instanceof Date) {
                cell.t = 'n';
                cell.z = XLSX.SSF._table[14];
                cell.v = datenum(value);
            }else if(typeof value === 'string') {
              if (value.match(/^[0-9]+[\.]?[0-9]*%$/)) {
                cell.z = '0.0%';
                cell.t = 'n';
                cell.v = Number(cell.v.substring(0, cell.v.length - 1)) / 100;
              }else{
                cell.t = 's'
              }
            }else{
              console.log("err: ", typeof value, value);
            }

            ws[cell_ref] = cell;
        }
    }
    if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    return ws;
}

function Workbook() {
    if (!(this instanceof Workbook)) return new Workbook();
    this.SheetNames = [];
    this.Sheets = {};
}

function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}

/**
 * 填充行合并占位符
 * */
 function pushRowSpanPlaceHolder(arr, count) {
  for (let i = 0; i < count; i++) {
    arr.push(null)
  }
}
// 填充列合并占位符
function pushColSpanPlaceHolder(arr, count) {
  for (let i = 0; i < count; i++) {
    arr.push('!$COL_SPAN_PLACEHOLDER')
  }
}
/**
 * 生成头部 
 * @param headers 展示的头部
 * @param excelHeader excel头部
 * @param deep 深度
 * @param perOffset 前置偏移量
 * @returns {number}  后置偏移量
 */
function getHeader(headers, excelHeader, deep, perOffset) {
  let offset = 0
  let cur = excelHeader[deep]
  if (!cur) {
    cur = excelHeader[deep] = []
  }
  // 填充行合并占位符
  pushRowSpanPlaceHolder(cur, perOffset - cur.length)
  for (let i = 0; i < headers.length; i++) {
    let head = headers[i]
    cur.push(head.label)
    if (head.hasOwnProperty('child') && Array.isArray(head.child)
      && head.child.length > 0) {
      let childOffset = getHeader(head.child, excelHeader, deep + 1,
        cur.length - 1)
      // 填充列合并占位符
      pushColSpanPlaceHolder(cur, childOffset - 1)
      offset += childOffset
    } else {
      offset++
    }
  }
  return offset;

}
/**
 * 构建excel表头
 * @param revealList 列表页面展示的表头
 * @returns {[]} excel表格展示的表头
 */
function buildHeader(revealList) {
  let excelHeader = [];
  // 构建生成excel表头需要的数据结构
  getHeader(revealList, excelHeader, 0, 0);
  // 多行表头长短不一，短的向长的看齐，不够的补上行合并占位符
  let max = Math.max(...(excelHeader.map(a => a.length)))
  excelHeader.filter(e => e.length < max).forEach(
    e => pushRowSpanPlaceHolder(e, max - e.length))
  return excelHeader;
}

function getMaxChildLength(map){
  let length = 0
  if(map['child']&&Array.isArray(map['child'])){
    length = length>map['child'].length?length:map['child'].length
    for(let child of map['child']){
      let tmpLength = getMaxChildLength(child)
      length = length>tmpLength?length:tmpLength
    }
  }
  return length
}
function getMaxChildDeep(map){
  let deep = 0
  if(map['child']&&Array.isArray(map['child'])){
    deep += 1
    let maxDeep = 0
    for(let child of map['child']){
      let tmpdeep = getMaxChildDeep(child)
      maxDeep = maxDeep>tmpdeep?maxDeep:tmpdeep
    }
    deep += maxDeep
  }
  return deep
}
/**
 * 合并头部单元格
 **/
 function doMerges(deep,revealList, index=0, preColEnd=0) {
  let mergeTitle = [], rowStart=0,rowEnd=0,colStart=0,colEnd=0
  for(let line of revealList){
    rowStart = index
    colStart = preColEnd
    if(line['child']&&Array.isArray(line['child'])){
      rowEnd = rowStart
    }else{
      rowEnd = deep - getMaxChildDeep(line)-1
    }
    colEnd = colStart + (getMaxChildLength(line) || 1)-1
    mergeTitle.push({
      s:{
        r: rowStart,
        c: colStart
      },
      e:{
        r: rowEnd,
        c: colEnd
      }
    })
    preColEnd = colEnd + 1
    if(line['child']&&Array.isArray(line['child'])){
      mergeTitle.push(...doMerges(deep, line['child'], index+1, colStart))
    }
  }
  return mergeTitle;
}
export function export_table_to_excel(id) {
    var theTable = document.getElementById(id);
    var oo = generateArray(theTable);
    var ranges = oo[1];

    /* original data */
    var data = oo[0];
    var ws_name = "SheetJS";

    var wb = new Workbook(),
        ws = sheet_from_array_of_arrays(data);

    /* add ranges to worksheet */
    // ws['!cols'] = ['apple', 'banan'];
    ws['!merges'] = ranges;

    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;

    var wbout = XLSX.write(wb, { bookType: 'xls', bookSST: false, type: 'binary' });

    saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), "test.xls")
}

export function export_json_to_excel(th, jsonData, defaultTitle) {

  /* original data */
  
  var data = jsonData;
  data.unshift(th);
  var ws_name = "SheetJS";

  var wb = new Workbook(),
      ws = sheet_from_array_of_arrays(data);


  /* add worksheet to workbook */
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  var wbout = XLSX.write(wb, { bookType: 'xls', bookSST: false, type: 'binary' });
  var title = defaultTitle || '列表'
  fileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), title + ".xls")
}
function formatJson(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => v[j]))
}

function getfilterVal(revealList){
  let filterVal = [], queue = []
  queue.push({"child":revealList})
  while(queue.length){
    let line = queue.shift()
    if(line['child']&&Array.isArray(line['child'])){
      for(let item of line['child']){
        queue.push(item)
      }
    }else{
      filterVal.push(line['prop'])
    }
  }
  return filterVal
}

function addStyle(workbookBlob, outlierList, ){
  return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
    workbook.sheets().forEach((sheet) =>{
      for([info, infoData] of Object.entries(outlierList)){
        // console.log({info, infoData}, sheet.name())
        if(sheet.name() === info){
          infoData.map(item => {
            if(item[1] === 'bg'){
              sheet.cell(item[0]).style({
                fill: "FF0000",
              });
            }else if(item[1] === 'font'){
              sheet.cell(item[0]).style({
                fontColor: 'FF0000'
              });
            }

          })
        }
      }
    })
    return workbook.outputAsync()
  })
}

/**
 * 
 * @param {*} writeData 写入数据，提供数据构成json: tabelType, 数据: tableData, sheetName
 * @param {*} excelName 表格名称
 * @param {*} outlier 数据范围，超出范围的cell背景变红，对应属性应该相等
 */
function exportToExcel(writeData, excelName, outlier=null) {
  var wb = XLSX.utils.book_new(), wbout;
  let outlierList = {}
  writeData.map(tabelInfo => {
    let tmpOutlierList = []
    let tHeader = buildHeader(tabelInfo.tableType)
    let mergeTitle = doMerges(tHeader.length,tabelInfo.tableType).sort((x,y)=>{
      if(x.s.r!==y.s.r){
        return x.s.r-y.s.r
      }else{
        return x.s.c-y.s.c
      }
    })
    let filterVal = getfilterVal(tabelInfo.tableType)
    let list = tabelInfo.tableData;
    let data = formatJson(filterVal, list);
    data.unshift(...tHeader);
    // console.log({filterVal})
    let worksheet = sheet_from_array_of_arrays(data)
    worksheet['!merges'] = mergeTitle
    if(outlier&&outlier[tabelInfo.sheetName]){
      let dateIndex = filterVal.findIndex(x=>x==='date')
      let dataSourceIndex = filterVal.findIndex(x=>x==='data_source')
      let accountIndex = filterVal.findIndex(x=>x==='account')
      let isOpenIndex = filterVal.findIndex(x=>x==='isOpen')
      outlier[tabelInfo.sheetName].map(item => {
        data.map((row, rowIndex) => {
          if(row[dateIndex] === item.date && row[dataSourceIndex] === item.data_source && row[accountIndex] === item.account && row[isOpenIndex] === item.isOpen){
            // console.log([row[dateIndex], item.date], [row[dataSourceIndex], item.data_source], [row[accountIndex], item.account])
            tmpOutlierList.push([XLSX.utils.encode_cell({ c: accountIndex, r: rowIndex }), 'bg'])
            item.props.map(prop => {
              tmpOutlierList.push([XLSX.utils.encode_cell({ c: filterVal.findIndex(x=>x===prop), r: rowIndex }), 'font'])
            })
          }
        })
      })
      if(tmpOutlierList[0]){
        outlierList[tabelInfo.sheetName] = tmpOutlierList
      }
    }
    // console.log({outlierList})
    /* add worksheet to workbook */
    wb.SheetNames.push(tabelInfo.sheetName);
    wb.Sheets[tabelInfo.sheetName] = worksheet;
  })
  wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'binary'});
  const workbookBlob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
  addStyle(workbookBlob, outlierList, ).then(
    (workbookBlob) => fileSaver.saveAs(workbookBlob,  excelName + ".xlsx")
  );
}

export default exportToExcel


// WEBPACK FOOTER //
// ./src/lib/Export2Excel.js